import type { ToastType } from './types';

export const DEFAULT_TOAST_DURATION: Record<ToastType, number> = {
  success: 5000,
  info: 5000,
  warning: 7000,
  error: 7000,
};

export const MAX_TOASTS = 5;
export const DEDUPE_WINDOW_MS = 800;

export function resolveToastDuration(type: ToastType, duration?: number): number {
  if (duration === 0) return 0;
  if (typeof duration === 'number' && duration > 0) return duration;
  return DEFAULT_TOAST_DURATION[type];
}

/** Extrai mensagem amigável de respostas de API / erros sem expor detalhes internos. */
export function getApiErrorMessage(error: unknown, fallback = 'Não foi possível concluir a operação.'): string {
  if (typeof error === 'string' && error.trim()) return error.trim();

  if (error && typeof error === 'object') {
    const maybe = error as {
      detail?: unknown;
      message?: unknown;
      response?: { data?: { detail?: unknown; message?: unknown } };
    };

    const detail =
      maybe.detail ??
      maybe.response?.data?.detail ??
      maybe.response?.data?.message ??
      maybe.message;

    if (typeof detail === 'string' && detail.trim()) return detail.trim();
    if (Array.isArray(detail)) {
      const parts = detail
        .map((item) => {
          if (typeof item === 'string') return item;
          if (item && typeof item === 'object' && 'msg' in item) {
            return String((item as { msg: unknown }).msg);
          }
          return '';
        })
        .filter(Boolean);
      if (parts.length) return parts.join(' ');
    }
    if (detail && typeof detail === 'object' && 'message' in detail) {
      const msg = (detail as { message?: unknown }).message;
      if (typeof msg === 'string' && msg.trim()) return msg.trim();
    }
  }

  return fallback;
}
